import { Company } from '../types/company'
import { generateCompanies } from './generateCompanies'
import { generateIndustryCode } from '../lib/industryCode'

export const mockCompanies: Company[] = [
  // AI/Tech Companies
  {
    id: '1',
    name: 'SenseTime',
    nameChinese: '商汤科技',
    industry: 'Artificial Intelligence',
    subIndustry: 'Computer Vision',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2014,
    employees: 5500,
    revenue: '$534M',
    patents: 8000,
    fundingRound: 'IPO',
    totalFunding: '$5.2B',
    description:
      'Leading AI software company specializing in computer vision and deep learning. Develops facial recognition, autonomous driving, and smart city solutions.',
    keyProducts: ['SenseCore AI Platform', 'SenseAuto', 'SenseCity', 'SenseME'],
    leadership: [
      { name: 'Xu Li', title: 'CEO' },
      { name: "Tang Xiao'ou", title: 'Founder & Chairman' },
      { name: 'Wang Xiaogang', title: 'Chief Scientist' },
    ],
    innovationScore: 94,
    website: 'sensetime.com',
    tags: [
      'Computer Vision',
      'Deep Learning',
      'Smart City',
      'Autonomous Driving',
    ],
    logo: '🤖',
  },
  {
    id: '2',
    name: 'Megvii',
    nameChinese: '旷视科技',
    industry: 'Artificial Intelligence',
    subIndustry: 'Computer Vision',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2011,
    employees: 3200,
    revenue: '$380M',
    patents: 2800,
    fundingRound: 'Series D',
    totalFunding: '$1.4B',
    description:
      'AI company known for Face++ facial recognition platform. Provides AI solutions for IoT, smart logistics, and urban management.',
    keyProducts: ['Face++', 'Brain++', 'Megvii Logistics', 'Hetu Platform'],
    leadership: [
      { name: 'Yin Qi', title: 'CEO' },
      { name: 'Tang Wenbin', title: 'CTO' },
    ],
    innovationScore: 89,
    website: 'megvii.com',
    tags: ['Facial Recognition', 'IoT', 'Smart Logistics', 'AI Platform'],
    logo: '👁️',
  },
  {
    id: '3',
    name: 'iFlytek',
    nameChinese: '科大讯飞',
    industry: 'Artificial Intelligence',
    subIndustry: 'Speech Recognition',
    city: 'Hefei',
    province: 'Anhui',
    founded: 1999,
    employees: 14000,
    revenue: '$2.1B',
    patents: 4500,
    fundingRound: 'IPO',
    totalFunding: '$1.8B',
    description:
      "China's leading speech and language AI company. Dominates Chinese voice recognition market with 70%+ market share.",
    keyProducts: [
      'iFlytek Voice Cloud',
      'Smart Education',
      'Smart Healthcare',
      'iFlytek Spark',
    ],
    leadership: [
      { name: 'Liu Qingfeng', title: 'Chairman & CEO' },
      { name: 'Hu Yu', title: 'President' },
    ],
    innovationScore: 91,
    website: 'iflytek.com',
    tags: ['Speech Recognition', 'NLP', 'Smart Education', 'Healthcare AI'],
    logo: '🎙️',
  },
  {
    id: '4',
    name: 'DJI',
    nameChinese: '大疆创新',
    industry: 'Robotics',
    subIndustry: 'Drones',
    city: 'Shenzhen',
    province: 'Guangdong',
    founded: 2006,
    employees: 14000,
    revenue: '$4.2B',
    patents: 6800,
    fundingRound: 'Series C',
    totalFunding: '$1B',
    description:
      "World's largest drone manufacturer controlling 70%+ of global consumer drone market. Expanding into enterprise and agricultural drones.",
    keyProducts: [
      'Mavic Series',
      'Phantom Series',
      'Matrice Enterprise',
      'Agras Agricultural',
    ],
    leadership: [
      { name: 'Frank Wang', title: 'Founder & CEO' },
      { name: 'Roger Luo', title: 'President' },
    ],
    innovationScore: 96,
    website: 'dji.com',
    tags: [
      'Drones',
      'Aerial Photography',
      'Enterprise Solutions',
      'Agriculture Tech',
    ],
    logo: '🚁',
  },
  {
    id: '5',
    name: 'ByteDance',
    nameChinese: '字节跳动',
    industry: 'Technology',
    subIndustry: 'Social Media & AI',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2012,
    employees: 150000,
    revenue: '$110B',
    patents: 12000,
    fundingRound: 'Series F',
    totalFunding: '$8.4B',
    description:
      'Global technology giant behind TikTok and Douyin. Pioneer in AI-driven content recommendation algorithms.',
    keyProducts: ['TikTok', 'Douyin', 'Toutiao', 'Lark', 'Pico VR'],
    leadership: [
      { name: 'Liang Rubo', title: 'CEO' },
      { name: 'Zhang Yiming', title: 'Founder' },
    ],
    innovationScore: 98,
    website: 'bytedance.com',
    tags: [
      'Social Media',
      'AI Recommendation',
      'Short Video',
      'Enterprise Software',
    ],
    logo: '📱',
  },
  {
    id: '6',
    name: 'Baidu',
    nameChinese: '百度',
    industry: 'Artificial Intelligence',
    subIndustry: 'Search & AI',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2000,
    employees: 42000,
    revenue: '$18.5B',
    patents: 15000,
    fundingRound: 'IPO',
    totalFunding: '$2.5B',
    description:
      "China's leading search engine and AI company. Major player in autonomous driving through Apollo platform.",
    keyProducts: [
      'Baidu Search',
      'Apollo AV',
      'Ernie Bot',
      'Baidu Cloud',
      'DuerOS',
    ],
    leadership: [
      { name: 'Robin Li', title: 'CEO & Co-founder' },
      { name: 'Dou Shen', title: 'EVP AI Cloud' },
    ],
    innovationScore: 93,
    website: 'baidu.com',
    tags: [
      'Search Engine',
      'Autonomous Driving',
      'Large Language Models',
      'Cloud',
    ],
    logo: '🔍',
  },
  {
    id: '7',
    name: 'Huawei Cloud',
    nameChinese: '华为云',
    industry: 'Cloud Computing',
    subIndustry: 'Enterprise Cloud',
    city: 'Shenzhen',
    province: 'Guangdong',
    founded: 2017,
    employees: 8000,
    revenue: '$12B',
    patents: 4200,
    fundingRound: 'Subsidiary',
    totalFunding: 'N/A',
    description:
      "Huawei's cloud computing division offering IaaS, PaaS, and AI services. Growing rapidly in Asia and Europe.",
    keyProducts: ['Huawei Cloud Stack', 'ModelArts', 'GaussDB', 'Pangu Models'],
    leadership: [
      { name: "Zhang Ping'an", title: 'CEO' },
      { name: 'Deng Tao', title: 'CTO' },
    ],
    innovationScore: 88,
    website: 'huaweicloud.com',
    tags: ['Cloud Computing', 'AI Platform', 'Database', 'Enterprise'],
    logo: '☁️',
  },
  {
    id: '8',
    name: 'Alibaba DAMO Academy',
    nameChinese: '阿里达摩院',
    industry: 'Artificial Intelligence',
    subIndustry: 'Research Lab',
    city: 'Hangzhou',
    province: 'Zhejiang',
    founded: 2017,
    employees: 1200,
    revenue: 'N/A',
    patents: 3500,
    fundingRound: 'Subsidiary',
    totalFunding: '$15B (committed)',
    description:
      "Alibaba's global research initiative focusing on fundamental AI, quantum computing, and chip design.",
    keyProducts: ['Tongyi Qianwen', 'Hanguang 800', 'City Brain', 'M6 Model'],
    leadership: [
      { name: 'Jeff Zhang', title: 'Head of DAMO' },
      { name: 'Jian Tan', title: 'VP AI' },
    ],
    innovationScore: 95,
    website: 'damo.alibaba.com',
    tags: ['Research', 'Quantum Computing', 'AI Chips', 'Large Models'],
    logo: '🔬',
  },
  {
    id: '9',
    name: 'Tencent AI Lab',
    nameChinese: '腾讯AI实验室',
    industry: 'Artificial Intelligence',
    subIndustry: 'Research Lab',
    city: 'Shenzhen',
    province: 'Guangdong',
    founded: 2016,
    employees: 800,
    revenue: 'N/A',
    patents: 2800,
    fundingRound: 'Subsidiary',
    totalFunding: 'N/A',
    description:
      "Tencent's AI research division focusing on NLP, computer vision, and game AI.",
    keyProducts: ['Hunyuan LLM', 'WeChat AI', 'Game AI', 'Medical AI'],
    leadership: [{ name: 'Zhang Zheng', title: 'Director' }],
    innovationScore: 90,
    website: 'ai.tencent.com',
    tags: ['NLP', 'Game AI', 'Medical AI', 'Research'],
    logo: '🎮',
  },
  {
    id: '10',
    name: 'CloudWalk',
    nameChinese: '云从科技',
    industry: 'Artificial Intelligence',
    subIndustry: 'Computer Vision',
    city: 'Guangzhou',
    province: 'Guangdong',
    founded: 2015,
    employees: 2000,
    revenue: '$180M',
    patents: 1800,
    fundingRound: 'IPO',
    totalFunding: '$800M',
    description:
      'AI company specializing in human-machine interaction. Strong presence in banking and public security sectors.',
    keyProducts: [
      'CloudWalk OS',
      'Face Recognition',
      'Smart Banking',
      'Security Solutions',
    ],
    leadership: [{ name: 'Zhou Xi', title: 'Founder & CEO' }],
    innovationScore: 82,
    website: 'cloudwalk.com',
    tags: [
      'Facial Recognition',
      'Banking',
      'Security',
      'Human-Machine Interaction',
    ],
    logo: '👤',
  },
  {
    id: '11',
    name: 'Yitu Technology',
    nameChinese: '依图科技',
    industry: 'Artificial Intelligence',
    subIndustry: 'Computer Vision',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2012,
    employees: 1500,
    revenue: '$150M',
    patents: 1200,
    fundingRound: 'Series D',
    totalFunding: '$600M',
    description:
      'AI company focusing on computer vision and voice recognition for healthcare and urban management.',
    keyProducts: [
      'Yitu Healthcare AI',
      'City Brain',
      'Voice Recognition',
      'AI Chips',
    ],
    leadership: [
      { name: 'Zhu Long', title: 'CEO & Co-founder' },
      { name: 'Lin Chenxi', title: 'Co-founder' },
    ],
    innovationScore: 84,
    website: 'yitutech.com',
    tags: ['Healthcare AI', 'Smart City', 'Voice Recognition', 'AI Chips'],
    logo: '🏥',
  },
  {
    id: '12',
    name: '4Paradigm',
    nameChinese: '第四范式',
    industry: 'Artificial Intelligence',
    subIndustry: 'Enterprise AI',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2014,
    employees: 2500,
    revenue: '$280M',
    patents: 900,
    fundingRound: 'IPO',
    totalFunding: '$700M',
    description:
      'Enterprise AI platform company helping businesses deploy machine learning at scale.',
    keyProducts: [
      'Sage Platform',
      'HyperCycle',
      'AutoML',
      'AI Decision Engine',
    ],
    leadership: [{ name: 'Dai Wenyuan', title: 'Founder & CEO' }],
    innovationScore: 86,
    website: '4paradigm.com',
    tags: ['Enterprise AI', 'AutoML', 'Decision Intelligence', 'Platform'],
    logo: '📊',
  },
  {
    id: '13',
    name: 'Momenta',
    nameChinese: '初速度',
    industry: 'Autonomous Driving',
    subIndustry: 'Full-Stack AV',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2016,
    employees: 1800,
    revenue: '$120M',
    patents: 1500,
    fundingRound: 'Series C',
    totalFunding: '$1.2B',
    description:
      'Autonomous driving company with dual approach: mass production ADAS and full self-driving technology.',
    keyProducts: ['Mpilot', 'MSD', 'Momenta GO', 'HD Mapping'],
    leadership: [{ name: 'Cao Xudong', title: 'CEO & Co-founder' }],
    innovationScore: 88,
    website: 'momenta.cn',
    tags: ['Autonomous Driving', 'ADAS', 'HD Mapping', 'L4 Autonomy'],
    logo: '🚗',
  },
  {
    id: '14',
    name: 'TuSimple',
    nameChinese: '图森未来',
    industry: 'Autonomous Driving',
    subIndustry: 'Autonomous Trucking',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2015,
    employees: 1200,
    revenue: '$45M',
    patents: 800,
    fundingRound: 'IPO',
    totalFunding: '$650M',
    description:
      'Autonomous trucking company developing self-driving technology for long-haul freight.',
    keyProducts: [
      'TuSimple ADS',
      'Autonomous Freight Network',
      'TuSimple Path',
    ],
    leadership: [
      { name: 'Cheng Lu', title: 'CEO' },
      { name: 'Xiaodi Hou', title: 'Founder & CTO' },
    ],
    innovationScore: 79,
    website: 'tusimple.com',
    tags: ['Autonomous Trucking', 'Logistics', 'L4 Autonomy', 'Freight'],
    logo: '🚛',
  },
  {
    id: '15',
    name: 'Zhipu AI',
    nameChinese: '智谱AI',
    industry: 'Artificial Intelligence',
    subIndustry: 'Large Language Models',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2019,
    employees: 600,
    revenue: '$80M',
    patents: 350,
    fundingRound: 'Series B',
    totalFunding: '$450M',
    description:
      'Leading Chinese LLM company spun off from Tsinghua University. Developer of GLM series models.',
    keyProducts: ['ChatGLM', 'GLM-4', 'CodeGeeX', 'Zhipu API'],
    leadership: [
      { name: 'Zhang Peng', title: 'CEO' },
      { name: 'Tang Jie', title: 'Chief Scientist' },
    ],
    innovationScore: 92,
    website: 'zhipuai.cn',
    tags: ['Large Language Models', 'Generative AI', 'Code Generation', 'API'],
    logo: '🧠',
  },
  {
    id: '16',
    name: 'MiniMax',
    nameChinese: 'MiniMax',
    industry: 'Artificial Intelligence',
    subIndustry: 'Large Language Models',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2021,
    employees: 400,
    revenue: '$50M',
    patents: 120,
    fundingRound: 'Series B',
    totalFunding: '$600M',
    description:
      'AI startup focused on multimodal large models. Known for text, voice, and video generation capabilities.',
    keyProducts: ['ABAB Model', 'Talkie', 'Hailuo AI', 'MiniMax API'],
    leadership: [{ name: 'Yan Junjie', title: 'CEO & Co-founder' }],
    innovationScore: 87,
    website: 'minimaxi.com',
    tags: [
      'Multimodal AI',
      'Voice Generation',
      'Video Generation',
      'Consumer AI',
    ],
    logo: '✨',
  },
  {
    id: '17',
    name: 'Moonshot AI',
    nameChinese: '月之暗面',
    industry: 'Artificial Intelligence',
    subIndustry: 'Large Language Models',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2023,
    employees: 200,
    revenue: '$20M',
    patents: 45,
    fundingRound: 'Series B',
    totalFunding: '$1B',
    description:
      'Fast-growing LLM startup known for Kimi chatbot with industry-leading long context window.',
    keyProducts: ['Kimi Chat', 'Moonshot API', 'Long Context Models'],
    leadership: [{ name: 'Yang Zhilin', title: 'CEO & Founder' }],
    innovationScore: 90,
    website: 'moonshot.cn',
    tags: ['Large Language Models', 'Long Context', 'Chatbot', 'API'],
    logo: '🌙',
  },
  {
    id: '18',
    name: '01.AI',
    nameChinese: '零一万物',
    industry: 'Artificial Intelligence',
    subIndustry: 'Large Language Models',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2023,
    employees: 300,
    revenue: '$15M',
    patents: 30,
    fundingRound: 'Series A',
    totalFunding: '$200M',
    description:
      'AI startup founded by Kai-Fu Lee focused on building open-source and commercial LLMs.',
    keyProducts: ['Yi-34B', 'Yi-6B', 'Yi Vision', 'Yi API'],
    leadership: [{ name: 'Kai-Fu Lee', title: 'CEO & Founder' }],
    innovationScore: 85,
    website: '01.ai',
    tags: ['Open Source AI', 'Large Language Models', 'Vision Models', 'API'],
    logo: '0️⃣',
  },
  // EV/Auto Companies
  {
    id: '19',
    name: 'BYD',
    nameChinese: '比亚迪',
    industry: 'Electric Vehicles',
    subIndustry: 'Full-Stack EV',
    city: 'Shenzhen',
    province: 'Guangdong',
    founded: 1995,
    employees: 570000,
    revenue: '$85B',
    patents: 28000,
    fundingRound: 'IPO',
    totalFunding: '$4.5B',
    description:
      "World's largest EV manufacturer. Vertically integrated with in-house batteries, chips, and motors.",
    keyProducts: ['Han EV', 'Seal', 'Dolphin', 'Blade Battery', 'Yangwang'],
    leadership: [
      { name: 'Wang Chuanfu', title: 'Chairman & CEO' },
      { name: 'Stella Li', title: 'EVP' },
    ],
    innovationScore: 97,
    website: 'byd.com',
    tags: [
      'Electric Vehicles',
      'Batteries',
      'Vertical Integration',
      'Mass Market',
    ],
    logo: '🔋',
  },
  {
    id: '20',
    name: 'NIO',
    nameChinese: '蔚来',
    industry: 'Electric Vehicles',
    subIndustry: 'Premium EV',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2014,
    employees: 32000,
    revenue: '$7.8B',
    patents: 6500,
    fundingRound: 'IPO',
    totalFunding: '$8.5B',
    description:
      'Premium EV maker known for battery swap technology and strong brand community.',
    keyProducts: ['ET7', 'ES8', 'EC6', 'Battery Swap Stations', 'NOMI AI'],
    leadership: [
      { name: 'William Li', title: 'Founder & CEO' },
      { name: 'Qin Lihong', title: 'Co-founder & President' },
    ],
    innovationScore: 91,
    website: 'nio.com',
    tags: ['Premium EV', 'Battery Swap', 'Smart Cockpit', 'Autonomous Driving'],
    logo: '⚡',
  },
  {
    id: '21',
    name: 'XPeng',
    nameChinese: '小鹏汽车',
    industry: 'Electric Vehicles',
    subIndustry: 'Smart EV',
    city: 'Guangzhou',
    province: 'Guangdong',
    founded: 2014,
    employees: 16000,
    revenue: '$4.2B',
    patents: 4200,
    fundingRound: 'IPO',
    totalFunding: '$5.2B',
    description:
      'Smart EV company focused on autonomous driving and intelligent features.',
    keyProducts: ['P7', 'G9', 'X9', 'XNGP', 'Flying Car'],
    leadership: [
      { name: 'He Xiaopeng', title: 'Chairman & CEO' },
      { name: 'Brian Gu', title: 'Vice Chairman & President' },
    ],
    innovationScore: 89,
    website: 'xpeng.com',
    tags: ['Smart EV', 'ADAS', 'Flying Cars', 'LiDAR'],
    logo: '🚀',
  },
  {
    id: '22',
    name: 'Li Auto',
    nameChinese: '理想汽车',
    industry: 'Electric Vehicles',
    subIndustry: 'Extended Range EV',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2015,
    employees: 25000,
    revenue: '$17.5B',
    patents: 3800,
    fundingRound: 'IPO',
    totalFunding: '$3.5B',
    description:
      'Family-focused EV maker pioneering extended-range electric vehicles in China.',
    keyProducts: ['L9', 'L8', 'L7', 'MEGA', 'Li AD Max'],
    leadership: [
      { name: 'Li Xiang', title: 'Founder & CEO' },
      { name: 'Shen Yanan', title: 'President' },
    ],
    innovationScore: 88,
    website: 'lixiang.com',
    tags: ['Extended Range', 'Family SUV', 'Smart Cockpit', 'ADAS'],
    logo: '🏠',
  },
  {
    id: '23',
    name: 'Zeekr',
    nameChinese: '极氪',
    industry: 'Electric Vehicles',
    subIndustry: 'Premium EV',
    city: 'Ningbo',
    province: 'Zhejiang',
    founded: 2021,
    employees: 8000,
    revenue: '$4.8B',
    patents: 1200,
    fundingRound: 'IPO',
    totalFunding: '$1.5B',
    description:
      "Geely's premium EV brand targeting tech-savvy consumers with performance vehicles.",
    keyProducts: ['Zeekr 001', 'Zeekr 009', 'Zeekr X', 'Zeekr 007'],
    leadership: [{ name: 'Andy An', title: 'CEO' }],
    innovationScore: 84,
    website: 'zeekrlife.com',
    tags: ['Premium EV', 'Performance', 'Geely Group', 'SEA Platform'],
    logo: '💫',
  },
  {
    id: '24',
    name: 'Leapmotor',
    nameChinese: '零跑汽车',
    industry: 'Electric Vehicles',
    subIndustry: 'Value EV',
    city: 'Hangzhou',
    province: 'Zhejiang',
    founded: 2015,
    employees: 12000,
    revenue: '$2.8B',
    patents: 2100,
    fundingRound: 'IPO',
    totalFunding: '$1.8B',
    description:
      'Cost-effective EV maker with strong vertical integration and in-house chip development.',
    keyProducts: ['C11', 'C01', 'T03', 'Leapmotor Chips'],
    leadership: [{ name: 'Zhu Jiangming', title: 'Founder & CEO' }],
    innovationScore: 80,
    website: 'leapmotor.com',
    tags: ['Value EV', 'Vertical Integration', 'In-house Chips', 'Mass Market'],
    logo: '🎯',
  },
  {
    id: '25',
    name: 'WM Motor',
    nameChinese: '威马汽车',
    industry: 'Electric Vehicles',
    subIndustry: 'Smart EV',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2015,
    employees: 4500,
    revenue: '$800M',
    patents: 1800,
    fundingRound: 'Series D',
    totalFunding: '$4.2B',
    description:
      'Smart EV startup focusing on intelligent mobility and autonomous driving.',
    keyProducts: ['W6', 'EX5', 'E5', 'Living Pilot'],
    leadership: [{ name: 'Freeman Shen', title: 'Founder & CEO' }],
    innovationScore: 72,
    website: 'wm-motor.com',
    tags: ['Smart EV', 'ADAS', 'Connected Car', 'Mid-range'],
    logo: '🌐',
  },
  {
    id: '26',
    name: 'HiPhi',
    nameChinese: '高合汽车',
    industry: 'Electric Vehicles',
    subIndustry: 'Luxury EV',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2019,
    employees: 3000,
    revenue: '$450M',
    patents: 800,
    fundingRound: 'Series B',
    totalFunding: '$1.2B',
    description:
      'Ultra-luxury EV brand known for innovative design and programmable features.',
    keyProducts: ['HiPhi X', 'HiPhi Z', 'HiPhi Y', 'PML Lights'],
    leadership: [{ name: 'David Ding', title: 'Founder & CEO' }],
    innovationScore: 78,
    website: 'hiphi.com',
    tags: ['Luxury EV', 'Innovative Design', 'Programmable', 'Premium'],
    logo: '💎',
  },
  {
    id: '27',
    name: 'Voyah',
    nameChinese: '岚图汽车',
    industry: 'Electric Vehicles',
    subIndustry: 'Premium EV',
    city: 'Wuhan',
    province: 'Hubei',
    founded: 2020,
    employees: 5000,
    revenue: '$1.2B',
    patents: 600,
    fundingRound: 'Subsidiary',
    totalFunding: 'N/A',
    description:
      "Dongfeng's premium EV brand offering luxury electric and EREV vehicles.",
    keyProducts: ['Voyah Free', 'Voyah Dreamer', 'Voyah Passion'],
    leadership: [{ name: 'Lu Fang', title: 'CEO' }],
    innovationScore: 76,
    website: 'voyah.com',
    tags: ['Premium EV', 'EREV', 'Dongfeng Group', 'Luxury'],
    logo: '🌊',
  },
  // Battery/Energy Companies
  {
    id: '28',
    name: 'CATL',
    nameChinese: '宁德时代',
    industry: 'Energy Storage',
    subIndustry: 'EV Batteries',
    city: 'Ningde',
    province: 'Fujian',
    founded: 2011,
    employees: 130000,
    revenue: '$50B',
    patents: 18000,
    fundingRound: 'IPO',
    totalFunding: '$3.5B',
    description:
      "World's largest EV battery manufacturer with 37% global market share.",
    keyProducts: [
      'Qilin Battery',
      'Shenxing Battery',
      'Sodium-ion Battery',
      'CTP Technology',
    ],
    leadership: [
      { name: 'Robin Zeng', title: 'Founder & Chairman' },
      { name: 'Zhou Jia', title: 'CEO' },
    ],
    innovationScore: 98,
    website: 'catl.com',
    tags: ['EV Batteries', 'Energy Storage', 'Sodium-ion', 'Global Leader'],
    logo: '🔌',
  },
  {
    id: '29',
    name: 'LONGi Green Energy',
    nameChinese: '隆基绿能',
    industry: 'Renewable Energy',
    subIndustry: 'Solar',
    city: "Xi'an",
    province: 'Shaanxi',
    founded: 2000,
    employees: 70000,
    revenue: '$18B',
    patents: 4500,
    fundingRound: 'IPO',
    totalFunding: '$2.1B',
    description: "World's largest solar wafer and module manufacturer.",
    keyProducts: ['Hi-MO 7', 'Solar Wafers', 'Solar Cells', 'HPBC Technology'],
    leadership: [
      { name: 'Li Zhenguo', title: 'Founder & President' },
      { name: 'Zhong Baoshen', title: 'Chairman' },
    ],
    innovationScore: 93,
    website: 'longi.com',
    tags: ['Solar', 'Monocrystalline', 'Green Energy', 'Manufacturing'],
    logo: '☀️',
  },
  {
    id: '30',
    name: 'Envision Group',
    nameChinese: '远景科技集团',
    industry: 'Renewable Energy',
    subIndustry: 'Wind & Batteries',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2007,
    employees: 8000,
    revenue: '$8B',
    patents: 3200,
    fundingRound: 'Series D',
    totalFunding: '$1.5B',
    description:
      'Green tech giant spanning wind turbines, batteries, and smart energy management.',
    keyProducts: [
      'Envision AESC Batteries',
      'Wind Turbines',
      'EnOS Platform',
      'Green Hydrogen',
    ],
    leadership: [{ name: 'Lei Zhang', title: 'Founder & CEO' }],
    innovationScore: 89,
    website: 'envision-group.com',
    tags: ['Wind Energy', 'Batteries', 'Smart Grid', 'Hydrogen'],
    logo: '💨',
  },
  {
    id: '31',
    name: 'JA Solar',
    nameChinese: '晶澳科技',
    industry: 'Renewable Energy',
    subIndustry: 'Solar',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2005,
    employees: 45000,
    revenue: '$12B',
    patents: 2800,
    fundingRound: 'IPO',
    totalFunding: '$1.2B',
    description:
      'Leading solar cell and module manufacturer with global presence.',
    keyProducts: [
      'DeepBlue 4.0',
      'Solar Cells',
      'Solar Modules',
      'Bycium+ Cells',
    ],
    leadership: [{ name: 'Jin Baofang', title: 'Chairman' }],
    innovationScore: 85,
    website: 'jasolar.com',
    tags: ['Solar', 'Photovoltaic', 'Manufacturing', 'Global'],
    logo: '🌞',
  },
  {
    id: '32',
    name: 'Trina Solar',
    nameChinese: '天合光能',
    industry: 'Renewable Energy',
    subIndustry: 'Solar',
    city: 'Changzhou',
    province: 'Jiangsu',
    founded: 1997,
    employees: 35000,
    revenue: '$11B',
    patents: 3100,
    fundingRound: 'IPO',
    totalFunding: '$1.8B',
    description:
      'Global solar solutions provider with integrated manufacturing.',
    keyProducts: ['Vertex Modules', 'TrinaTracker', 'TrinaPro', '210mm Cells'],
    leadership: [{ name: 'Gao Jifan', title: 'Founder & Chairman' }],
    innovationScore: 86,
    website: 'trinasolar.com',
    tags: ['Solar', 'Tracking Systems', 'Utility Scale', 'Manufacturing'],
    logo: '🔆',
  },
  {
    id: '33',
    name: 'GoodWe',
    nameChinese: '固德威',
    industry: 'Renewable Energy',
    subIndustry: 'Solar Inverters',
    city: 'Suzhou',
    province: 'Jiangsu',
    founded: 2010,
    employees: 4500,
    revenue: '$1.8B',
    patents: 1200,
    fundingRound: 'IPO',
    totalFunding: '$350M',
    description:
      'Leading solar inverter manufacturer for residential and commercial applications.',
    keyProducts: [
      'String Inverters',
      'Hybrid Inverters',
      'Energy Storage',
      'Smart Energy Management',
    ],
    leadership: [{ name: 'Huang Min', title: 'Chairman & CEO' }],
    innovationScore: 81,
    website: 'goodwe.com',
    tags: ['Solar Inverters', 'Energy Storage', 'Smart Home', 'Residential'],
    logo: '⚙️',
  },
  // Biotech/Pharma Companies
  {
    id: '34',
    name: 'BGI Genomics',
    nameChinese: '华大基因',
    industry: 'Biotechnology',
    subIndustry: 'Genomics',
    city: 'Shenzhen',
    province: 'Guangdong',
    founded: 1999,
    employees: 8500,
    revenue: '$1.2B',
    patents: 3500,
    fundingRound: 'IPO',
    totalFunding: '$800M',
    description:
      "World's largest genomics organization providing sequencing services and research.",
    keyProducts: [
      'DNBSEQ Sequencers',
      'NIFTY Test',
      'MGI Tech',
      'Genomic Services',
    ],
    leadership: [
      { name: 'Wang Jian', title: 'Co-founder & Chairman' },
      { name: 'Yin Ye', title: 'CEO' },
    ],
    innovationScore: 92,
    website: 'bgi.com',
    tags: ['Genomics', 'Sequencing', 'Prenatal Testing', 'Research'],
    logo: '🧬',
  },
  {
    id: '35',
    name: 'BeiGene',
    nameChinese: '百济神州',
    industry: 'Biotechnology',
    subIndustry: 'Oncology',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2010,
    employees: 10000,
    revenue: '$2.5B',
    patents: 1800,
    fundingRound: 'IPO',
    totalFunding: '$4.5B',
    description:
      'Global biotechnology company focused on developing innovative cancer treatments.',
    keyProducts: ['Brukinsa', 'Tislelizumab', 'Pamiparib', 'Zanubrutinib'],
    leadership: [
      { name: 'John Oyler', title: 'Co-founder & CEO' },
      { name: 'Xiaodong Wang', title: 'Co-founder' },
    ],
    innovationScore: 90,
    website: 'beigene.com',
    tags: ['Oncology', 'Immunotherapy', 'Drug Discovery', 'Global Biotech'],
    logo: '💊',
  },
  {
    id: '36',
    name: 'Zai Lab',
    nameChinese: '再鼎医药',
    industry: 'Biotechnology',
    subIndustry: 'Biopharma',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2014,
    employees: 2500,
    revenue: '$650M',
    patents: 450,
    fundingRound: 'IPO',
    totalFunding: '$1.8B',
    description:
      'Innovative biopharma company focused on bringing transformative medicines to China.',
    keyProducts: ['Zejula', 'Optune', 'Nuzyra', 'TIVDAK'],
    leadership: [{ name: 'Samantha Du', title: 'Founder & CEO' }],
    innovationScore: 85,
    website: 'zailaboratory.com',
    tags: ['Oncology', 'Infectious Disease', 'Autoimmune', 'Licensing'],
    logo: '🔬',
  },
  {
    id: '37',
    name: 'Innovent Biologics',
    nameChinese: '信达生物',
    industry: 'Biotechnology',
    subIndustry: 'Biologics',
    city: 'Suzhou',
    province: 'Jiangsu',
    founded: 2011,
    employees: 6000,
    revenue: '$850M',
    patents: 1200,
    fundingRound: 'IPO',
    totalFunding: '$1.5B',
    description:
      'Biopharmaceutical company developing high-quality biologics for cancer and autoimmune diseases.',
    keyProducts: ['Sintilimab', 'Tyvyt', 'Byvasda', 'Sulinno'],
    leadership: [{ name: 'Michael Yu', title: 'Founder & CEO' }],
    innovationScore: 87,
    website: 'innoventbio.com',
    tags: ['Biologics', 'PD-1', 'Biosimilars', 'Oncology'],
    logo: '🧪',
  },
  {
    id: '38',
    name: 'Legend Biotech',
    nameChinese: '传奇生物',
    industry: 'Biotechnology',
    subIndustry: 'Cell Therapy',
    city: 'Nanjing',
    province: 'Jiangsu',
    founded: 2014,
    employees: 2800,
    revenue: '$480M',
    patents: 650,
    fundingRound: 'IPO',
    totalFunding: '$800M',
    description:
      'Global cell therapy company pioneering CAR-T treatments for cancer.',
    keyProducts: ['Carvykti', 'CAR-T Platform', 'Cell Therapy Pipeline'],
    leadership: [{ name: 'Ying Huang', title: 'CEO' }],
    innovationScore: 91,
    website: 'legendbiotech.com',
    tags: ['CAR-T', 'Cell Therapy', 'Oncology', 'Immunotherapy'],
    logo: '🦠',
  },
  {
    id: '39',
    name: 'WuXi AppTec',
    nameChinese: '药明康德',
    industry: 'Biotechnology',
    subIndustry: 'CRO/CDMO',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2000,
    employees: 45000,
    revenue: '$6.5B',
    patents: 4200,
    fundingRound: 'IPO',
    totalFunding: '$2.8B',
    description:
      'Global pharmaceutical and biotech open-access platform enabling drug R&D.',
    keyProducts: [
      'Drug Discovery Services',
      'CDMO Services',
      'Testing Services',
      'WuXi Biology',
    ],
    leadership: [
      { name: 'Ge Li', title: 'Founder & Chairman' },
      { name: 'Edward Hu', title: 'CEO' },
    ],
    innovationScore: 88,
    website: 'wuxiapptec.com',
    tags: ['CRO', 'CDMO', 'Drug Discovery', 'Contract Research'],
    logo: '⚗️',
  },
  {
    id: '40',
    name: 'Hengrui Medicine',
    nameChinese: '恒瑞医药',
    industry: 'Pharmaceuticals',
    subIndustry: 'Innovative Drugs',
    city: 'Lianyungang',
    province: 'Jiangsu',
    founded: 1970,
    employees: 28000,
    revenue: '$3.8B',
    patents: 5500,
    fundingRound: 'IPO',
    totalFunding: '$1.2B',
    description:
      "China's largest innovative pharmaceutical company with strong oncology pipeline.",
    keyProducts: ['Camrelizumab', 'Apatinib', 'Pyrotinib', 'Anesthetics'],
    leadership: [
      { name: 'Sun Piaoyang', title: 'Chairman' },
      { name: 'Zhou Yunshu', title: 'CEO' },
    ],
    innovationScore: 86,
    website: 'hengrui.com',
    tags: ['Oncology', 'Innovative Drugs', 'Generic Drugs', 'R&D'],
    logo: '💉',
  },
  // Semiconductor Companies
  {
    id: '41',
    name: 'SMIC',
    nameChinese: '中芯国际',
    industry: 'Semiconductors',
    subIndustry: 'Foundry',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2000,
    employees: 20000,
    revenue: '$7.2B',
    patents: 12000,
    fundingRound: 'IPO',
    totalFunding: '$5.5B',
    description:
      "China's largest semiconductor foundry providing wafer fabrication services.",
    keyProducts: [
      '14nm Process',
      '28nm Process',
      'Wafer Fabrication',
      'IC Manufacturing',
    ],
    leadership: [
      { name: 'Zhao Haijun', title: 'Co-CEO' },
      { name: 'Liang Mengsong', title: 'Co-CEO' },
    ],
    innovationScore: 85,
    website: 'smics.com',
    tags: ['Foundry', 'Wafer Fab', 'Advanced Process', 'IC Manufacturing'],
    logo: '🔲',
  },
  {
    id: '42',
    name: 'Cambricon',
    nameChinese: '寒武纪',
    industry: 'Semiconductors',
    subIndustry: 'AI Chips',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2016,
    employees: 1800,
    revenue: '$120M',
    patents: 2800,
    fundingRound: 'IPO',
    totalFunding: '$450M',
    description:
      'Leading AI chip company developing neural network processors and accelerators.',
    keyProducts: ['MLU370', 'MLU290', 'Siyuan Chips', 'AI Training Cards'],
    leadership: [{ name: 'Chen Tianshi', title: 'Founder & CEO' }],
    innovationScore: 84,
    website: 'cambricon.com',
    tags: ['AI Chips', 'Neural Networks', 'Accelerators', 'Edge AI'],
    logo: '🧮',
  },
  {
    id: '43',
    name: 'Horizon Robotics',
    nameChinese: '地平线',
    industry: 'Semiconductors',
    subIndustry: 'Automotive Chips',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2015,
    employees: 4000,
    revenue: '$350M',
    patents: 2200,
    fundingRound: 'Series D',
    totalFunding: '$2.5B',
    description:
      'Leading automotive AI chip company providing solutions for intelligent driving.',
    keyProducts: ['Journey 5', 'Journey 6', 'Sunrise Chips', 'TogetherOS'],
    leadership: [{ name: 'Yu Kai', title: 'Founder & CEO' }],
    innovationScore: 89,
    website: 'horizon.ai',
    tags: ['Automotive Chips', 'ADAS', 'Edge AI', 'Autonomous Driving'],
    logo: '🚙',
  },
  {
    id: '44',
    name: 'Biren Technology',
    nameChinese: '壁仞科技',
    industry: 'Semiconductors',
    subIndustry: 'GPU',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2019,
    employees: 1200,
    revenue: '$50M',
    patents: 450,
    fundingRound: 'Series B',
    totalFunding: '$700M',
    description:
      'High-performance GPU startup developing chips for AI and HPC workloads.',
    keyProducts: ['BR100', 'BR104', 'BIRENSUPA', 'GPU Accelerators'],
    leadership: [{ name: 'Zhang Wen', title: 'Founder & CEO' }],
    innovationScore: 82,
    website: 'birentech.com',
    tags: ['GPU', 'AI Accelerators', 'HPC', 'Data Center'],
    logo: '🖥️',
  },
  {
    id: '45',
    name: 'Moore Threads',
    nameChinese: '摩尔线程',
    industry: 'Semiconductors',
    subIndustry: 'GPU',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2020,
    employees: 800,
    revenue: '$30M',
    patents: 280,
    fundingRound: 'Series B',
    totalFunding: '$450M',
    description:
      'GPU startup developing full-function graphics processors for gaming and AI.',
    keyProducts: ['MTT S80', 'MTT S70', 'MUSA Architecture', 'Gaming GPUs'],
    leadership: [{ name: 'Zhang Jianzhong', title: 'Founder & CEO' }],
    innovationScore: 78,
    website: 'mthreads.com',
    tags: ['GPU', 'Gaming', 'Graphics', 'AI Acceleration'],
    logo: '🎮',
  },
  {
    id: '46',
    name: 'YMTC',
    nameChinese: '长江存储',
    industry: 'Semiconductors',
    subIndustry: 'Memory',
    city: 'Wuhan',
    province: 'Hubei',
    founded: 2016,
    employees: 15000,
    revenue: '$2.5B',
    patents: 6500,
    fundingRound: 'Series C',
    totalFunding: '$24B',
    description:
      "China's leading NAND flash memory manufacturer developing advanced 3D NAND.",
    keyProducts: [
      'Xtacking',
      '232-Layer NAND',
      'SSD Controllers',
      'Flash Memory',
    ],
    leadership: [{ name: 'Chen Nanxiang', title: 'CEO' }],
    innovationScore: 87,
    website: 'ymtc.com',
    tags: ['NAND Flash', 'Memory', '3D NAND', 'Storage'],
    logo: '💾',
  },
  {
    id: '47',
    name: 'Naura Technology',
    nameChinese: '北方华创',
    industry: 'Semiconductors',
    subIndustry: 'Equipment',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2001,
    employees: 8500,
    revenue: '$1.8B',
    patents: 4200,
    fundingRound: 'IPO',
    totalFunding: '$800M',
    description:
      'Leading semiconductor equipment manufacturer providing etching and deposition tools.',
    keyProducts: ['Etching Systems', 'PVD Systems', 'CVD Systems', 'Furnaces'],
    leadership: [{ name: 'Zhao Jin', title: 'Chairman' }],
    innovationScore: 83,
    website: 'naura.com',
    tags: ['Semiconductor Equipment', 'Etching', 'Deposition', 'Manufacturing'],
    logo: '🏭',
  },
  // Fintech Companies
  {
    id: '48',
    name: 'Ant Group',
    nameChinese: '蚂蚁集团',
    industry: 'Fintech',
    subIndustry: 'Digital Payments',
    city: 'Hangzhou',
    province: 'Zhejiang',
    founded: 2014,
    employees: 25000,
    revenue: '$22B',
    patents: 8500,
    fundingRound: 'Series C',
    totalFunding: '$22B',
    description:
      "World's largest fintech company operating Alipay and various financial services.",
    keyProducts: [
      'Alipay',
      "Yu'e Bao",
      'Ant Fortune',
      'MYbank',
      'Zhima Credit',
    ],
    leadership: [
      { name: 'Eric Jing', title: 'Executive Chairman' },
      { name: 'Simon Hu', title: 'CEO' },
    ],
    innovationScore: 95,
    website: 'antgroup.com',
    tags: [
      'Digital Payments',
      'Wealth Management',
      'Credit Scoring',
      'Blockchain',
    ],
    logo: '🐜',
  },
  {
    id: '49',
    name: 'WeBank',
    nameChinese: '微众银行',
    industry: 'Fintech',
    subIndustry: 'Digital Banking',
    city: 'Shenzhen',
    province: 'Guangdong',
    founded: 2014,
    employees: 3500,
    revenue: '$3.2B',
    patents: 2800,
    fundingRound: 'Subsidiary',
    totalFunding: 'N/A',
    description:
      "China's first digital-only bank backed by Tencent, serving SMEs and consumers.",
    keyProducts: [
      'Weilidai',
      'Weiyedai',
      'FATE Platform',
      'Blockchain Services',
    ],
    leadership: [{ name: 'Gu Min', title: 'Chairman' }],
    innovationScore: 88,
    website: 'webank.com',
    tags: [
      'Digital Banking',
      'SME Lending',
      'Federated Learning',
      'Blockchain',
    ],
    logo: '🏦',
  },
  {
    id: '50',
    name: 'Lufax',
    nameChinese: '陆金所',
    industry: 'Fintech',
    subIndustry: 'Wealth Management',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2011,
    employees: 8000,
    revenue: '$4.5B',
    patents: 1200,
    fundingRound: 'IPO',
    totalFunding: '$2.5B',
    description:
      'Leading wealth management and lending platform backed by Ping An.',
    keyProducts: [
      'Wealth Management',
      'Consumer Lending',
      'SME Lending',
      'Insurance',
    ],
    leadership: [{ name: 'YS Cho', title: 'Chairman & CEO' }],
    innovationScore: 82,
    website: 'lufax.com',
    tags: ['Wealth Management', 'P2P Lending', 'Insurance', 'Ping An'],
    logo: '💰',
  },
  {
    id: '51',
    name: 'JD Technology',
    nameChinese: '京东科技',
    industry: 'Fintech',
    subIndustry: 'Enterprise Tech',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2013,
    employees: 12000,
    revenue: '$5.8B',
    patents: 3500,
    fundingRound: 'Series B',
    totalFunding: '$3.2B',
    description:
      "JD's technology arm providing fintech, cloud, and AI solutions.",
    keyProducts: [
      'JD Finance',
      'JD Cloud',
      'Supply Chain Finance',
      'AI Solutions',
    ],
    leadership: [{ name: 'Li Yayun', title: 'CEO' }],
    innovationScore: 84,
    website: 'jdcloud.com',
    tags: ['Supply Chain Finance', 'Cloud', 'AI', 'Enterprise'],
    logo: '🛒',
  },
  {
    id: '52',
    name: 'OneConnect',
    nameChinese: '金融壹账通',
    industry: 'Fintech',
    subIndustry: 'B2B Fintech',
    city: 'Shenzhen',
    province: 'Guangdong',
    founded: 2015,
    employees: 4500,
    revenue: '$580M',
    patents: 1800,
    fundingRound: 'IPO',
    totalFunding: '$1.2B',
    description:
      'Technology-as-a-service platform for financial institutions backed by Ping An.',
    keyProducts: [
      'Smart Banking',
      'Smart Insurance',
      'Smart Investment',
      'Gamma Platform',
    ],
    leadership: [{ name: 'Shen Chongfeng', title: 'Chairman & CEO' }],
    innovationScore: 79,
    website: 'ocft.com',
    tags: ['B2B Fintech', 'Banking Tech', 'Insurance Tech', 'Ping An'],
    logo: '🔗',
  },
  // Robotics Companies
  {
    id: '53',
    name: 'UBTech Robotics',
    nameChinese: '优必选',
    industry: 'Robotics',
    subIndustry: 'Humanoid Robots',
    city: 'Shenzhen',
    province: 'Guangdong',
    founded: 2012,
    employees: 3500,
    revenue: '$450M',
    patents: 2800,
    fundingRound: 'IPO',
    totalFunding: '$1B',
    description:
      'Leading humanoid robot company developing service and educational robots.',
    keyProducts: ['Walker X', 'Cruzr', 'Alpha Series', 'STEM Education Robots'],
    leadership: [{ name: 'James Zhou', title: 'Founder & CEO' }],
    innovationScore: 86,
    website: 'ubtrobot.com',
    tags: ['Humanoid Robots', 'Service Robots', 'Education', 'AI'],
    logo: '🤖',
  },
  {
    id: '54',
    name: 'Geek+',
    nameChinese: '极智嘉',
    industry: 'Robotics',
    subIndustry: 'Logistics Robots',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2015,
    employees: 2000,
    revenue: '$380M',
    patents: 1500,
    fundingRound: 'Series E',
    totalFunding: '$700M',
    description:
      'Global leader in autonomous mobile robots for warehouse logistics.',
    keyProducts: [
      'Picking Robots',
      'Sorting Robots',
      'Moving Robots',
      'Geek+ Brain',
    ],
    leadership: [{ name: 'Yong Zheng', title: 'Founder & CEO' }],
    innovationScore: 85,
    website: 'geekplus.com',
    tags: ['AMR', 'Warehouse Automation', 'Logistics', 'E-commerce'],
    logo: '📦',
  },
  {
    id: '55',
    name: 'Dobot',
    nameChinese: '越疆科技',
    industry: 'Robotics',
    subIndustry: 'Collaborative Robots',
    city: 'Shenzhen',
    province: 'Guangdong',
    founded: 2015,
    employees: 800,
    revenue: '$120M',
    patents: 900,
    fundingRound: 'Series D',
    totalFunding: '$200M',
    description:
      'Collaborative robot manufacturer for education and light industrial applications.',
    keyProducts: [
      'Dobot Magician',
      'CR Series',
      'Nova Series',
      'Education Kits',
    ],
    leadership: [{ name: 'Liu Peichao', title: 'Founder & CEO' }],
    innovationScore: 80,
    website: 'dobot.cc',
    tags: ['Cobots', 'Education Robots', 'Light Industry', 'Desktop Arms'],
    logo: '🦾',
  },
  {
    id: '56',
    name: 'Agile Robots',
    nameChinese: '思灵机器人',
    industry: 'Robotics',
    subIndustry: 'Intelligent Robots',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2018,
    employees: 600,
    revenue: '$80M',
    patents: 450,
    fundingRound: 'Series C',
    totalFunding: '$350M',
    description:
      'Intelligent robot company combining AI with force-controlled manipulation.',
    keyProducts: [
      'Diana 7',
      'Agile Controller',
      'Force Control',
      'Medical Robots',
    ],
    leadership: [
      { name: 'Peter Meusel', title: 'Co-founder & CEO' },
      { name: 'Zhaopeng Chen', title: 'Co-founder & CTO' },
    ],
    innovationScore: 83,
    website: 'agile-robots.com',
    tags: ['Force Control', 'AI Robotics', 'Medical', 'Manufacturing'],
    logo: '🔧',
  },
  // Space/Aerospace Companies
  {
    id: '57',
    name: 'iSpace',
    nameChinese: '星际荣耀',
    industry: 'Aerospace',
    subIndustry: 'Launch Vehicles',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2016,
    employees: 800,
    revenue: '$45M',
    patents: 350,
    fundingRound: 'Series B',
    totalFunding: '$350M',
    description:
      "Private space company that achieved China's first private orbital launch.",
    keyProducts: [
      'Hyperbola-1',
      'Hyperbola-2',
      'Hyperbola-3',
      'Reusable Rockets',
    ],
    leadership: [{ name: 'Peng Xiaobo', title: 'Founder & CEO' }],
    innovationScore: 84,
    website: 'i-space.com.cn',
    tags: ['Launch Vehicles', 'Private Space', 'Reusable Rockets', 'Orbital'],
    logo: '🚀',
  },
  {
    id: '58',
    name: 'LandSpace',
    nameChinese: '蓝箭航天',
    industry: 'Aerospace',
    subIndustry: 'Launch Vehicles',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2015,
    employees: 1200,
    revenue: '$60M',
    patents: 480,
    fundingRound: 'Series D',
    totalFunding: '$600M',
    description:
      'First Chinese private company to develop methane-powered rockets.',
    keyProducts: ['Zhuque-2', 'Zhuque-3', 'TQ-12 Engine', 'Methane Rockets'],
    leadership: [{ name: 'Zhang Changwu', title: 'Founder & CEO' }],
    innovationScore: 87,
    website: 'landspace.com',
    tags: ['Methane Rockets', 'Launch Vehicles', 'Private Space', 'Reusable'],
    logo: '🔥',
  },
  {
    id: '59',
    name: 'Galactic Energy',
    nameChinese: '星河动力',
    industry: 'Aerospace',
    subIndustry: 'Launch Vehicles',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2018,
    employees: 600,
    revenue: '$35M',
    patents: 280,
    fundingRound: 'Series C',
    totalFunding: '$280M',
    description:
      'Commercial launch company with successful solid and liquid rocket programs.',
    keyProducts: ['Ceres-1', 'Pallas-1', 'Solid Rockets', 'Liquid Rockets'],
    leadership: [{ name: 'Liu Baiqi', title: 'Founder & CEO' }],
    innovationScore: 81,
    website: 'galactic-energy.cn',
    tags: ['Commercial Launch', 'Solid Rockets', 'Small Satellites', 'LEO'],
    logo: '🌟',
  },
  {
    id: '60',
    name: 'SpaceSail',
    nameChinese: '时空道宇',
    industry: 'Aerospace',
    subIndustry: 'Satellite Services',
    city: 'Hangzhou',
    province: 'Zhejiang',
    founded: 2018,
    employees: 500,
    revenue: '$25M',
    patents: 220,
    fundingRound: 'Series B',
    totalFunding: '$200M',
    description:
      'Geely-backed satellite company building constellation for connected vehicles.',
    keyProducts: [
      'GeeSat Constellation',
      'Satellite IoT',
      'Vehicle Connectivity',
      'LEO Satellites',
    ],
    leadership: [{ name: 'Wang Hongliang', title: 'CEO' }],
    innovationScore: 77,
    website: 'geespace.com',
    tags: ['Satellite Constellation', 'IoT', 'Connected Vehicles', 'Geely'],
    logo: '🛰️',
  },
  // Additional AI Companies
  {
    id: '61',
    name: 'DeepSeek',
    nameChinese: '深度求索',
    industry: 'Artificial Intelligence',
    subIndustry: 'Large Language Models',
    city: 'Hangzhou',
    province: 'Zhejiang',
    founded: 2023,
    employees: 150,
    revenue: '$10M',
    patents: 25,
    fundingRound: 'Seed',
    totalFunding: '$100M',
    description:
      'AI research lab developing open-source large language models with strong reasoning.',
    keyProducts: [
      'DeepSeek-V2',
      'DeepSeek Coder',
      'DeepSeek Math',
      'Open Source Models',
    ],
    leadership: [{ name: 'Liang Wenfeng', title: 'Founder' }],
    innovationScore: 88,
    website: 'deepseek.com',
    tags: ['Open Source AI', 'LLM', 'Code Generation', 'Reasoning'],
    logo: '🔮',
  },
  {
    id: '62',
    name: 'Baichuan AI',
    nameChinese: '百川智能',
    industry: 'Artificial Intelligence',
    subIndustry: 'Large Language Models',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2023,
    employees: 200,
    revenue: '$15M',
    patents: 35,
    fundingRound: 'Series A',
    totalFunding: '$350M',
    description:
      'LLM startup founded by former Sogou CEO, developing bilingual AI models.',
    keyProducts: [
      'Baichuan-2',
      'Baichuan-53B',
      'Baichuan API',
      'Enterprise Solutions',
    ],
    leadership: [{ name: 'Wang Xiaochuan', title: 'Founder & CEO' }],
    innovationScore: 85,
    website: 'baichuan-ai.com',
    tags: ['LLM', 'Bilingual AI', 'Enterprise AI', 'Open Source'],
    logo: '🌊',
  },
  {
    id: '63',
    name: 'StepFun',
    nameChinese: '阶跃星辰',
    industry: 'Artificial Intelligence',
    subIndustry: 'Large Language Models',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2023,
    employees: 180,
    revenue: '$12M',
    patents: 28,
    fundingRound: 'Series A',
    totalFunding: '$200M',
    description:
      'AI startup developing multimodal large models with strong visual understanding.',
    keyProducts: ['Step-1', 'Step-1V', 'Yuebao', 'Multimodal API'],
    leadership: [{ name: 'Jiang Daxin', title: 'Founder & CEO' }],
    innovationScore: 83,
    website: 'stepfun.com',
    tags: ['Multimodal AI', 'Vision Models', 'LLM', 'Consumer AI'],
    logo: '👣',
  },
  // Additional EV/Auto Companies
  {
    id: '64',
    name: 'Neta Auto',
    nameChinese: '哪吒汽车',
    industry: 'Electric Vehicles',
    subIndustry: 'Value EV',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2014,
    employees: 8000,
    revenue: '$2.2B',
    patents: 1800,
    fundingRound: 'Series D',
    totalFunding: '$1.5B',
    description:
      'Affordable EV maker targeting mass market with competitive pricing.',
    keyProducts: ['Neta S', 'Neta GT', 'Neta X', 'Neta V'],
    leadership: [{ name: 'Zhang Yong', title: 'CEO' }],
    innovationScore: 75,
    website: 'hozonauto.com',
    tags: ['Affordable EV', 'Mass Market', 'Smart Features', 'Youth'],
    logo: '🔱',
  },
  {
    id: '65',
    name: 'Aion',
    nameChinese: '埃安',
    industry: 'Electric Vehicles',
    subIndustry: 'Smart EV',
    city: 'Guangzhou',
    province: 'Guangdong',
    founded: 2017,
    employees: 15000,
    revenue: '$6.5B',
    patents: 2500,
    fundingRound: 'Series A',
    totalFunding: '$2.5B',
    description:
      "GAC's premium EV brand known for fast-charging technology and smart features.",
    keyProducts: ['Aion S', 'Aion LX', 'Aion V', 'Hyper GT', 'Hyper SSR'],
    leadership: [{ name: 'Gu Huinan', title: 'CEO' }],
    innovationScore: 82,
    website: 'aion.com.cn',
    tags: ['Smart EV', 'Fast Charging', 'GAC Group', 'Premium'],
    logo: '⭐',
  },
  // Additional Battery Companies
  {
    id: '66',
    name: 'EVE Energy',
    nameChinese: '亿纬锂能',
    industry: 'Energy Storage',
    subIndustry: 'Batteries',
    city: 'Huizhou',
    province: 'Guangdong',
    founded: 2001,
    employees: 35000,
    revenue: '$8.5B',
    patents: 5500,
    fundingRound: 'IPO',
    totalFunding: '$1.2B',
    description:
      'Major lithium battery manufacturer for EVs, consumer electronics, and energy storage.',
    keyProducts: [
      'Power Batteries',
      'Consumer Batteries',
      'Energy Storage',
      'LFP Cells',
    ],
    leadership: [{ name: 'Liu Jincheng', title: 'Chairman' }],
    innovationScore: 84,
    website: 'evebattery.com',
    tags: ['Lithium Batteries', 'EV Batteries', 'Energy Storage', 'Consumer'],
    logo: '🔋',
  },
  {
    id: '67',
    name: 'CALB',
    nameChinese: '中创新航',
    industry: 'Energy Storage',
    subIndustry: 'EV Batteries',
    city: 'Changzhou',
    province: 'Jiangsu',
    founded: 2007,
    employees: 18000,
    revenue: '$4.8B',
    patents: 3200,
    fundingRound: 'IPO',
    totalFunding: '$800M',
    description:
      'Third-largest EV battery maker in China with strong OEM partnerships.',
    keyProducts: [
      'One-Stop Battery',
      'LFP Batteries',
      'Ternary Batteries',
      'CTP Technology',
    ],
    leadership: [{ name: 'Liu Jingyu', title: 'Chairman' }],
    innovationScore: 82,
    website: 'calb-tech.com',
    tags: ['EV Batteries', 'LFP', 'Ternary', 'OEM Supply'],
    logo: '⚡',
  },
  // Additional Semiconductor Companies
  {
    id: '68',
    name: 'Loongson',
    nameChinese: '龙芯中科',
    industry: 'Semiconductors',
    subIndustry: 'CPU',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2010,
    employees: 2500,
    revenue: '$180M',
    patents: 2800,
    fundingRound: 'IPO',
    totalFunding: '$450M',
    description:
      'Domestic CPU developer creating processors based on LoongArch architecture.',
    keyProducts: [
      'Loongson 3A6000',
      'Loongson 3C5000',
      'LoongArch',
      'Server CPUs',
    ],
    leadership: [{ name: 'Hu Weiwu', title: 'Chairman' }],
    innovationScore: 81,
    website: 'loongson.cn',
    tags: ['CPU', 'Domestic Chips', 'LoongArch', 'Server'],
    logo: '🐉',
  },
  {
    id: '69',
    name: 'Zhaoxin',
    nameChinese: '兆芯',
    industry: 'Semiconductors',
    subIndustry: 'CPU',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2013,
    employees: 1500,
    revenue: '$120M',
    patents: 1800,
    fundingRound: 'Series C',
    totalFunding: '$350M',
    description:
      'x86-compatible CPU developer for desktop and server applications.',
    keyProducts: ['KX-7000', 'KH-40000', 'x86 CPUs', 'Integrated Chips'],
    leadership: [{ name: 'Ye Feng', title: 'CEO' }],
    innovationScore: 76,
    website: 'zhaoxin.com',
    tags: ['x86 CPU', 'Desktop', 'Server', 'Domestic'],
    logo: '💻',
  },
  // Additional Biotech Companies
  {
    id: '70',
    name: 'Akeso',
    nameChinese: '康方生物',
    industry: 'Biotechnology',
    subIndustry: 'Antibodies',
    city: 'Zhongshan',
    province: 'Guangdong',
    founded: 2012,
    employees: 2800,
    revenue: '$420M',
    patents: 850,
    fundingRound: 'IPO',
    totalFunding: '$650M',
    description:
      'Biopharmaceutical company specializing in innovative antibody drugs.',
    keyProducts: [
      'Cadonilimab',
      'Ivonescimab',
      'Bispecific Antibodies',
      'PD-1/CTLA-4',
    ],
    leadership: [{ name: 'Xia Yu', title: 'Founder & CEO' }],
    innovationScore: 86,
    website: 'akesobio.com',
    tags: ['Bispecific Antibodies', 'Oncology', 'Immunotherapy', 'Innovation'],
    logo: '🧫',
  },
  {
    id: '71',
    name: 'Junshi Biosciences',
    nameChinese: '君实生物',
    industry: 'Biotechnology',
    subIndustry: 'Immunotherapy',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2012,
    employees: 3500,
    revenue: '$580M',
    patents: 1100,
    fundingRound: 'IPO',
    totalFunding: '$1.2B',
    description:
      'Innovative biopharmaceutical company focused on immunotherapy and oncology.',
    keyProducts: ['Toripalimab', 'JS001', 'COVID-19 Antibody', 'ADC Platform'],
    leadership: [{ name: 'Li Ning', title: 'CEO' }],
    innovationScore: 84,
    website: 'junshipharma.com',
    tags: ['PD-1', 'Immunotherapy', 'Oncology', 'COVID-19'],
    logo: '💉',
  },
  // Additional Tech Companies
  {
    id: '72',
    name: 'Xiaomi',
    nameChinese: '小米',
    industry: 'Technology',
    subIndustry: 'Consumer Electronics',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2010,
    employees: 35000,
    revenue: '$42B',
    patents: 38000,
    fundingRound: 'IPO',
    totalFunding: '$1.5B',
    description:
      'Global technology company spanning smartphones, IoT, and now electric vehicles.',
    keyProducts: ['Xiaomi 14', 'Redmi', 'Mi Home', 'Xiaomi SU7', 'MIUI'],
    leadership: [{ name: 'Lei Jun', title: 'Founder & CEO' }],
    innovationScore: 90,
    website: 'mi.com',
    tags: ['Smartphones', 'IoT', 'Electric Vehicles', 'Smart Home'],
    logo: '📱',
  },
  {
    id: '73',
    name: 'OPPO',
    nameChinese: 'OPPO',
    industry: 'Technology',
    subIndustry: 'Consumer Electronics',
    city: 'Dongguan',
    province: 'Guangdong',
    founded: 2004,
    employees: 40000,
    revenue: '$32B',
    patents: 25000,
    fundingRound: 'Private',
    totalFunding: 'N/A',
    description:
      'Major smartphone manufacturer known for camera innovation and fast charging.',
    keyProducts: ['Find X7', 'Reno Series', 'VOOC Charging', 'ColorOS'],
    leadership: [{ name: 'Tony Chen', title: 'CEO' }],
    innovationScore: 85,
    website: 'oppo.com',
    tags: ['Smartphones', 'Camera Tech', 'Fast Charging', 'BBK'],
    logo: '📷',
  },
  {
    id: '74',
    name: 'Vivo',
    nameChinese: 'Vivo',
    industry: 'Technology',
    subIndustry: 'Consumer Electronics',
    city: 'Dongguan',
    province: 'Guangdong',
    founded: 2009,
    employees: 35000,
    revenue: '$28B',
    patents: 18000,
    fundingRound: 'Private',
    totalFunding: 'N/A',
    description:
      'Smartphone brand focusing on camera, audio, and design innovation.',
    keyProducts: ['X100 Pro', 'V Series', 'iQOO', 'OriginOS'],
    leadership: [{ name: 'Shen Wei', title: 'CEO' }],
    innovationScore: 83,
    website: 'vivo.com',
    tags: ['Smartphones', 'Camera', 'Audio', 'BBK'],
    logo: '🎵',
  },
  {
    id: '75',
    name: 'Honor',
    nameChinese: '荣耀',
    industry: 'Technology',
    subIndustry: 'Consumer Electronics',
    city: 'Shenzhen',
    province: 'Guangdong',
    founded: 2013,
    employees: 12000,
    revenue: '$15B',
    patents: 8500,
    fundingRound: 'Series A',
    totalFunding: '$3B',
    description:
      'Former Huawei sub-brand now independent, focusing on premium smartphones.',
    keyProducts: ['Magic6 Pro', 'Magic V2', 'MagicOS', 'Honor Tablets'],
    leadership: [{ name: 'George Zhao', title: 'CEO' }],
    innovationScore: 84,
    website: 'hihonor.com',
    tags: ['Smartphones', 'Foldables', 'AI', 'Premium'],
    logo: '✨',
  },
  // Additional Robotics/Automation
  {
    id: '76',
    name: 'Siasun',
    nameChinese: '新松机器人',
    industry: 'Robotics',
    subIndustry: 'Industrial Robots',
    city: 'Shenyang',
    province: 'Liaoning',
    founded: 2000,
    employees: 5500,
    revenue: '$680M',
    patents: 3800,
    fundingRound: 'IPO',
    totalFunding: '$450M',
    description:
      "China's largest industrial robot manufacturer with comprehensive automation solutions.",
    keyProducts: [
      'Industrial Robots',
      'Collaborative Robots',
      'AGVs',
      'Smart Factory',
    ],
    leadership: [{ name: 'Qu Daokui', title: 'President' }],
    innovationScore: 82,
    website: 'siasun.com',
    tags: ['Industrial Robots', 'Automation', 'AGV', 'Smart Manufacturing'],
    logo: '🏭',
  },
  {
    id: '77',
    name: 'Estun Automation',
    nameChinese: '埃斯顿',
    industry: 'Robotics',
    subIndustry: 'Industrial Robots',
    city: 'Nanjing',
    province: 'Jiangsu',
    founded: 1993,
    employees: 4200,
    revenue: '$520M',
    patents: 2100,
    fundingRound: 'IPO',
    totalFunding: '$280M',
    description:
      'Industrial automation company providing robots and motion control systems.',
    keyProducts: [
      'ER Series Robots',
      'Servo Systems',
      'CNC Systems',
      'Welding Robots',
    ],
    leadership: [{ name: 'Wu Bo', title: 'Chairman' }],
    innovationScore: 79,
    website: 'estun.com',
    tags: ['Industrial Robots', 'Servo', 'CNC', 'Welding'],
    logo: '⚙️',
  },
  // Additional Energy Companies
  {
    id: '78',
    name: 'Sungrow',
    nameChinese: '阳光电源',
    industry: 'Renewable Energy',
    subIndustry: 'Solar Inverters',
    city: 'Hefei',
    province: 'Anhui',
    founded: 1997,
    employees: 12000,
    revenue: '$8.5B',
    patents: 4200,
    fundingRound: 'IPO',
    totalFunding: '$650M',
    description:
      "World's largest solar inverter manufacturer and energy storage provider.",
    keyProducts: [
      'String Inverters',
      'Central Inverters',
      'Energy Storage',
      'Floating PV',
    ],
    leadership: [{ name: 'Cao Renxian', title: 'Chairman' }],
    innovationScore: 88,
    website: 'sungrowpower.com',
    tags: ['Solar Inverters', 'Energy Storage', 'Floating Solar', 'Global'],
    logo: '🌅',
  },
  {
    id: '79',
    name: 'Risen Energy',
    nameChinese: '东方日升',
    industry: 'Renewable Energy',
    subIndustry: 'Solar',
    city: 'Ningbo',
    province: 'Zhejiang',
    founded: 1986,
    employees: 18000,
    revenue: '$6.2B',
    patents: 1800,
    fundingRound: 'IPO',
    totalFunding: '$480M',
    description:
      'Integrated solar company providing cells, modules, and project development.',
    keyProducts: [
      'HJT Modules',
      'TOPCon Cells',
      'Solar Projects',
      'Energy Storage',
    ],
    leadership: [{ name: 'Lin Haifeng', title: 'Chairman' }],
    innovationScore: 81,
    website: 'risenenergy.com',
    tags: ['Solar Modules', 'HJT', 'Project Development', 'Manufacturing'],
    logo: '🌄',
  },
  {
    id: '80',
    name: 'Gotion High-Tech',
    nameChinese: '国轩高科',
    industry: 'Energy Storage',
    subIndustry: 'EV Batteries',
    city: 'Hefei',
    province: 'Anhui',
    founded: 2006,
    employees: 22000,
    revenue: '$4.2B',
    patents: 4800,
    fundingRound: 'IPO',
    totalFunding: '$1.5B',
    description:
      'Major EV battery manufacturer with VW partnership and LFP expertise.',
    keyProducts: [
      'LFP Batteries',
      'Semi-solid Batteries',
      'Energy Storage',
      'Battery Packs',
    ],
    leadership: [{ name: 'Li Zhen', title: 'Chairman' }],
    innovationScore: 83,
    website: 'gotion.com.cn',
    tags: ['LFP Batteries', 'VW Partnership', 'Semi-solid', 'Energy Storage'],
    logo: '🔌',
  },
  // Additional AI/Tech Companies
  {
    id: '81',
    name: 'SambaNova',
    nameChinese: 'SambaNova中国',
    industry: 'Artificial Intelligence',
    subIndustry: 'AI Hardware',
    city: 'Shanghai',
    province: 'Shanghai',
    founded: 2017,
    employees: 150,
    revenue: '$25M',
    patents: 180,
    fundingRound: 'Series D',
    totalFunding: '$1.1B',
    description:
      'AI hardware company with China operations providing enterprise AI solutions.',
    keyProducts: [
      'DataScale',
      'SambaNova Suite',
      'AI Training',
      'Inference Systems',
    ],
    leadership: [{ name: 'China GM', title: 'General Manager' }],
    innovationScore: 80,
    website: 'sambanova.ai',
    tags: ['AI Hardware', 'Enterprise AI', 'Training', 'Inference'],
    logo: '🔷',
  },
  {
    id: '82',
    name: 'Haomo AI',
    nameChinese: '毫末智行',
    industry: 'Autonomous Driving',
    subIndustry: 'ADAS',
    city: 'Beijing',
    province: 'Beijing',
    founded: 2019,
    employees: 1500,
    revenue: '$85M',
    patents: 680,
    fundingRound: 'Series B',
    totalFunding: '$450M',
    description:
      "Great Wall Motors' autonomous driving spinoff focusing on mass-market ADAS.",
    keyProducts: ['HPilot', 'DriveGPT', 'NOH', 'Autonomous Trucks'],
    leadership: [{ name: 'Zhang Kai', title: 'CEO' }],
    innovationScore: 82,
    website: 'haomo.ai',
    tags: ['ADAS', 'Autonomous Driving', 'Great Wall', 'Mass Market'],
    logo: '🛣️',
  },
  {
    id: '83',
    name: 'WeRide',
    nameChinese: '文远知行',
    industry: 'Autonomous Driving',
    subIndustry: 'Robotaxi',
    city: 'Guangzhou',
    province: 'Guangdong',
    founded: 2017,
    employees: 1200,
    revenue: '$45M',
    patents: 850,
    fundingRound: 'Series D',
    totalFunding: '$1.3B',
    description:
      'L4 autonomous driving company operating robotaxi and robobus services.',
    keyProducts: ['Robotaxi', 'Robobus', 'Robovan', 'WeRide One'],
    leadership: [{ name: 'Tony Han', title: 'Founder & CEO' }],
    innovationScore: 86,
    website: 'weride.ai',
    tags: ['Robotaxi', 'L4 Autonomy', 'Robobus', 'Commercial'],
    logo: '🚕',
  },
  {
    id: '84',
    name: 'Pony.ai',
    nameChinese: '小马智行',
    industry: 'Autonomous Driving',
    subIndustry: 'Robotaxi',
    city: 'Guangzhou',
    province: 'Guangdong',
    founded: 2016,
    employees: 1000,
    revenue: '$35M',
    patents: 720,
    fundingRound: 'Series D',
    totalFunding: '$1.1B',
    description:
      'Leading autonomous driving company with robotaxi operations in China and US.',
    keyProducts: ['Robotaxi', 'Robotruck', 'PonyPilot+', 'AV Platform'],
    leadership: [
      { name: 'James Peng', title: 'Co-founder & CEO' },
      { name: 'Lou Tiancheng', title: 'Co-founder & CTO' },
    ],
    innovationScore: 87,
    website: 'pony.ai',
    tags: ['Robotaxi', 'Robotruck', 'L4 Autonomy', 'Global'],
    logo: '🐴',
  },
  {
    id: '85',
    name: 'AutoX',
    nameChinese: '安途',
    industry: 'Autonomous Driving',
    subIndustry: 'Robotaxi',
    city: 'Shenzhen',
    province: 'Guangdong',
    founded: 2016,
    employees: 800,
    revenue: '$28M',
    patents: 580,
    fundingRound: 'Series B',
    totalFunding: '$560M',
    description:
      'Autonomous driving company known for fully driverless robotaxi operations.',
    keyProducts: [
      'Gen5 Robotaxi',
      'AutoX Driver',
      'xUrban',
      'Driverless Operations',
    ],
    leadership: [{ name: 'Jianxiong Xiao', title: 'Founder & CEO' }],
    innovationScore: 84,
    website: 'autox.ai',
    tags: ['Driverless', 'Robotaxi', 'L4 Autonomy', 'Shenzhen'],
    logo: '🤖',
  },
]

const mockCompaniesWithCodes: Company[] = mockCompanies.map((c) => ({
  ...c,
  industryCode: generateIndustryCode(
    c.industry,
    c.subIndustry,
    c.founded,
    c.id,
  ),
})) as Company[]

const generatedCompanies = generateCompanies(1000, 86)

export const allCompanies: Company[] = [
  ...mockCompaniesWithCodes,
  ...generatedCompanies,
]

export const industries = [
  ...new Set(allCompanies.map((c) => c.industry)),
].sort()
export const cities = [...new Set(allCompanies.map((c) => c.city))].sort()
export const provinces = [
  ...new Set(allCompanies.map((c) => c.province)),
].sort()
export const fundingRounds = [
  ...new Set(allCompanies.map((c) => c.fundingRound)),
].sort()
export const allTags = [...new Set(allCompanies.flatMap((c) => c.tags))].sort()
